import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface Guide {
  id: number;
  icon: string;
  title: string;
  description: string;
  tips: string[];
}

const guides: Guide[] = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: 'Essential Camping Gear',
    description: 'Everything you need for a comfortable and safe camping experience in the Hudson Valley.',
    tips: [
      'Quality tent with rainfly for weather protection',
      'Sleeping bag rated for the season',
      'Portable camping stove and cookware',
      'First aid kit and emergency supplies',
      'Headlamp or flashlight with extra batteries',
      'Water filtration system or purification tablets',
    ],
  },
  {
    id: 2,
    icon: 'ri-map-2-line',
    title: 'Trip Planning Essentials',
    description: 'Master the art of planning your perfect outdoor adventure with these expert tips.',
    tips: [
      'Book campsites 2-3 months in advance for peak season',
      'Check weather forecasts and trail conditions',
      'Create a detailed itinerary and share with someone',
      'Research nearby facilities and services',
      'Plan meals and pack appropriate food storage',
      'Download offline maps for areas with no cell service',
    ],
  },
  {
    id: 3,
    icon: 'ri-truck-line',
    title: 'RV Basics & Maintenance',
    description: 'Learn everything you need to know about RVing, from driving tips to regular maintenance.',
    tips: [
      'Practice driving and backing up in an empty parking lot',
      'Check tire pressure and tread before each trip',
      'Understand your RV\'s weight limits and capacity',
      'Learn proper hookup procedures for utilities',
      'Winterize your RV to prevent freeze damage',
      'Keep a maintenance log and follow service schedules',
    ],
  },
  {
    id: 4,
    icon: 'ri-fire-line',
    title: 'Campfire Safety',
    description: 'Enjoy campfires responsibly while protecting the environment and staying safe.',
    tips: [
      'Check for fire bans and restrictions before starting',
      'Use established fire rings when available',
      'Keep fires small and manageable',
      'Never leave a fire unattended',
      'Keep water and shovel nearby for emergencies',
      'Ensure fire is completely out before leaving',
    ],
  },
  {
    id: 5,
    icon: 'ri-restaurant-line',
    title: 'Outdoor Cooking Tips',
    description: 'Prepare delicious meals in the great outdoors with these practical cooking tips.',
    tips: [
      'Prep ingredients at home to save time at camp',
      'Use cast iron cookware for even heat distribution',
      'Pack spices in small containers to save space',
      'Store food properly to prevent wildlife encounters',
      'Bring aluminum foil for easy cleanup',
      'Try one-pot meals for simple preparation',
    ],
  },
  {
    id: 6,
    icon: 'ri-shield-check-line',
    title: 'Wildlife Safety',
    description: 'Coexist safely with wildlife while camping in the Hudson Valley region.',
    tips: [
      'Store food in bear-proof containers or hang properly',
      'Keep a clean campsite to avoid attracting animals',
      'Make noise while hiking to avoid surprising wildlife',
      'Never feed or approach wild animals',
      'Know what to do if you encounter a bear',
      'Keep pets on leash and under control',
    ],
  },
];

const TipsGuidesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24">
        <section className="py-20 bg-[#F5F1E8]">
          <div className="max-w-7xl mx-auto px-6">
            <h1 className="font-serif text-6xl font-bold text-gray-900 mb-6">Tips & Guides</h1>
            <p className="text-xl text-gray-600 max-w-3xl">
              Expert advice and practical tips to help you make the most of your camping and RVing adventures in the Hudson Valley.
            </p>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-2 gap-8">
              {guides.map((guide) => (
                <article
                  key={guide.id}
                  className="bg-gray-50 rounded-2xl p-10 hover:bg-white hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-16 h-16 flex items-center justify-center mb-6">
                    <i className={`${guide.icon} text-6xl text-gray-900`}></i>
                  </div>
                  
                  <h3 className="font-bold text-3xl text-gray-900 mb-4">
                    {guide.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {guide.description}
                  </p>

                  <ul className="space-y-3">
                    {guide.tips.map((tip, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-forest text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-gray-700 text-sm leading-relaxed">{tip}</span>
                      </li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TipsGuidesPage;